// extracted by mini-css-extract-plugin
export default {"section":"Family_section__P9q9v","container":"Family_container__InrwE","container__photo":"Family_container__photo__zxkwz","photo":"Family_photo__VopcY"};